import { Donuz } from "donuz-js/Donuz";
// @ is an alias to /src
export default {
    name: "login",
    data() {
        return {
            obj: {},
            cpf: "",
            password: "",
            forgotPassword: null,
            email: ''
        };
    },
    async created() {
        this.obj = await this.getAdmins();
        this.obj = this.obj.estabelecimentos[0];
        var elems = document.querySelectorAll('.modal');
        var instance = M.Modal.init(elems, { opacity: 0.5 });
    },
    methods: {
        submit: async function(e) {
            e.preventDefault();
            let result = await Donuz.customer.signIn(this.cpf, this.password);
            if (result.status == 200) {
                M.toast({ html: 'Login efetuado!', classes: "green" });
                let client = result.clientes[0];
                let saldo = await Donuz.balance.getCustomerBalance(result.token);
                client.saldo = parseFloat(saldo.saldo)
                    .toFixed(2)
                    .replace(".", ",");
                sessionStorage.setItem(btoa("cliente"), btoa(JSON.stringify(client)));
                sessionStorage.setItem(btoa("tokenCliente"), result.token);
                location.href = this.baseUrl;
            } else {
                M.toast({ html: 'Acesso negado!', classes: "red" });
            }
        },
        forgot: async function(e) {
            e.preventDefault();
            let result = await Donuz.customer.forgotPassword(this.email)
            if (result.status == 200) {
                M.toast({ html: result.mensagem, classes: "green" });
            } else {
                M.toast({ html: 'Acesso negado!', classes: "red" });
            }
        }
    }
};